// extracted by mini-css-extract-plugin
export default {"wrapper":"DropdownSelect_wrapper__GaXoY","errorMessage":"DropdownSelect_errorMessage__1l6Sd"};